<template>
<v-container>
	<v-layout>
		<h3>{{label}}</h3>
	</v-layout>
	<v-layout v-for="item in list">
		<v-flex d-flex>
			<div class="item" v-if="item.key !== 'id'">
				<div>
					{{ item.key ? '{' + item.key + '} :' : '' }}
					{ {{ item.value }} }
				</div>
			</div>
			<div>
				<v-btn small fab dark color="red lighten-2">
					<v-icon @click="remove(item)">delete</v-icon>
				</v-btn>
				<v-btn small fab dark color="indigo lighten-2">
					<v-icon @click="edit(item)">edit</v-icon>
				</v-btn>
			</div>
		</v-flex>
	</v-layout>
	<v-dialog
		v-model="dialog"
		persistent
		width="500"
	>
		<v-card>
			<v-card-title
				class="headline light-blue darken-1 white--text"
				primary-title
			>
				{{$t('common.item')}}
			</v-card-title>

			<v-card-text>
				<v-container grid-list-lg>
					<v-layout>
						<v-flex md12>
							<v-layout column>
								<v-flex v-if="!onlyValue">
									<v-text-field label="Key" v-model="formData.key" />
								</v-flex>
								<v-flex>
									<v-text-field label="Value" v-model="formData.value" />
								</v-flex>
								<v-flex class="pay-btn" d-flex>
									<v-btn @click="add" color="indigo" dark>
										{{$t('common.add')}}
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn
					color="red light-1"
					flat
					@click="close"
				>
					{{$t('common.cancel')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-btn
		@click="open"
		color="indigo"
		dark
	>
		{{$t('common.add_new')}}
	</v-btn>
</v-container>
</template>

<script>
import { TEMPLATE_SETTING_ITEM } from '../../constants'

export default {
	data: () => ({
		dialog: false,
		formData: { ...TEMPLATE_SETTING_ITEM }
	}),
	props: {
		list: {
			type: Array
		},
		label: {
			type: String,
			default: ''
		},
		onlyValue: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		remove(item) {
			this.$emit('remove', item.id)
		},
		edit(item) {
			this.setFormData(item)
			this.open()
		},
		add() {
			if (this.formData.id === 0) {
				this.$emit('add', { ...this.formData, id: +new Date() })
			} else {
				this.$emit('edit', this.formData)
			}
			this.close()
		},
		close() {
			this.dialog = false
			this.setFormData(TEMPLATE_SETTING_ITEM)
		},
		open() {
			this.dialog = true
		},
		setFormData(data) {
			this.formData = { ...data }
		}
	}
}
</script>

<style scoped>
.item {
	display: flex;
	flex-direction: row;
}
.delete-contact {
	cursor: pointer;
	user-select: none;
}
</style>
